import categories from "./categories"

const colors = {
  white: "#ffffff",
  inputWhite: "#ffffffc7",
  inputPlaceholder: "#aaaaaa",
  black: "#000000",
  resultBackground: "#ECE7E1",
  orangeHighlight: "#D06434",
  infoOrangeUnderline: "#DCC19E",
  tooltipBackgroundOrange: "#EBDECD",
  [categories.amaro]: "#F57C7C",
  [categories.liqueur]: "#F57C7C",
  [categories.aperitif]: "#F57C7C",
  [categories.rum]: "#9E4200",
  [categories.brandy]: "#D66014",
  [categories.whiskey]: "#D66014",
  [categories.cognac]: "#D66014",
  [categories.vodka]: "#F1F2F2",
  [categories.gin]: "#F1F2F2",
  [categories.mezcal]: "#A9C2B0",
  [categories.tequila]: "#D6EDC7",
  [categories.absinthe]: "#859E75",
  [categories.vermouth]: "#891576",
  [categories.cachaca]: "#7DBFD3",
  [categories.pisco]: "#7DAA8A",
  [categories.sparklingWine]: "#F5E29D",
  [categories.sherry]: "#CC5747",
  [categories.sake]: "#A5B7BD",
  [categories.lemonJuice]: "#F0DA89",
  [categories.limeJuice]: "#A7CE95",
  [categories.orangeJuice]: "#EBB76D",
  [categories.peachPuree]: "#FFBEA9",
  [categories.cranberryJuice]: "#D54333",
  [categories.cola]: "#F2CFA4",
  [categories.gingerAle]: "#F2CFA4",
  [categories.gingerBeer]: "#F2CFA4",
  [categories.grapefruitSoda]: "#E5B0B6",
  [categories.tonicWater]: "#D0E7EE",
  [categories.clubSoda]: "#D0E7EE",
  [categories.seltzer]: "#D0E7EE",
  [categories.nonalchoholic]: "#D0E7EE",
}

export default colors
